<style lang="scss">
.test-page {
  .--attention {
    animation: attention 1.2s ease-in-out infinite;
  }

  // Vuetify - VStepper
  .v-stepper {
    box-shadow: none;
  }

  .v-stepper__step__step,
  .v-stepper__step__step .v-icon,
  .v-stepper__label {
    font-size: 24px;
  }

  .v-stepper__step__step {
    width: 48px;
    min-height: 48px;
    height: 48px;
  }

  @keyframes attention {
    0% {
      transform: scale(1);
    }

    20%,
    80% {
      transform: scale(1.05);
    }

    40%,
    60% {
      transform: scale(1.03);
    }
  }
}
</style>

<template>
  <v-card width="90%" height="85%" flat class="test-page">
    <v-stepper v-model="current">
      <v-stepper-header>
        <template v-for="step in steps">
          <v-stepper-step
            :key="`step-${step.n}`"
            :step="step.n"
            :complete="step.complete"
            :color="step.color"
          >
            {{ step.text }}
          </v-stepper-step>

          <v-divider v-if="step.n !== length" :key="step.n" />
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-for="step in steps"
          :key="`step-content-${step.n}`"
          :step="step.n"
        >
          <component
            v-if="isCurrent(step.n)"
            :is="step.component"
            @notify="handleNotify"
            @valid="handleValid"
          />
        </v-stepper-content>
        <notify ref="notify" />
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
import Notify from '@/components/test-steps/notify'
import FootSwitch from '@/components/test-steps/foot-switch'
import PermissionCamera from '@/components/test-steps/permission-camera'
import PermissionMicrophone from '@/components/test-steps/permission-microphone'

export default {
  name: 'TestPage',
  components: {
    Notify,
    FootSwitch,
    PermissionCamera,
    PermissionMicrophone,
  },
  data() {
    return {
      current: 1,
      steps: [
        {
          n: 1,
          component: 'FootSwitch',
          text: '踏板',
          complete: false,
          color: 'primary',
        },
        {
          n: 2,
          component: 'PermissionCamera',
          text: '攝影機',
          complete: false,
          color: 'primary',
        },
        {
          n: 3,
          component: 'PermissionMicrophone',
          text: '麥克風',
          complete: false,
          color: 'primary',
        },
      ],
    }
  },
  computed: {
    length() {
      return this.steps.length
    },
    stepComponent() {
      switch (this.current) {
        case 1:
          return FootSwitch
        case 2:
          return PermissionCamera
        case 3:
          return PermissionMicrophone
        default:
          return ''
      }
    },
  },
  methods: {
    isCurrent(step) {
      return this.current === step
    },
    prevStep() {
      if (this.current !== 1) {
        this.current = this.current - 1
      }
    },
    nextStep() {
      if (this.current !== this.length) {
        this.current = this.current + 1
      }
    },
    handleNotify(type = 'success') {
      if (this.$refs.notify) {
        this.$refs.notify.show(type)
      }
    },
    handleValid({ step, valid }) {
      this.steps = this.steps.map(item => {
        if (item.n === step) {
          if (valid) {
            return {
              ...item,
              complete: true,
              color: 'green',
              rules: [],
            }
          }
          return {
            ...item,
            color: 'error',
            rules: [() => false],
          }
        }
        return item
      })

      if (valid) {
        this.nextStep()
      }

      if (!valid) {
        this.handleNotify('error')
      }
    },
  },
}
</script>
